<app-section #parentSection
             [formConfig]="formConfig"
             [sectionRef]="section"
             [formGroup]="formGroup"
             [title]="title"
             [key]="key"
             [editMode]="true">

    <ng-template #section>

        <app-section-data-presentation *ngIf="previewMode"
                                       [parentSection]="parentSection"
                                       [formGroup]="formGroup"
                                       [formConfig]="formConfig"
                                       [displayedFields]="dataPresentationFields">
        </app-section-data-presentation>

        <div class="col" [ngClass]="{'col-preview-mode': previewMode}">
            <div *ngIf="canFieldDisplayed(consts.VEHICLE_CONDITION)" class="section__component col-50">
                <app-select
                        [errorsMap]="formFactoryService.errorsMap"
                        [control]="formGroup.controls[consts.VEHICLE_CONDITION]"
                        [fieldConfig]="formFactoryService.fieldConfig(consts.VEHICLE_CONDITION, formConfig)"
                        [context]="formConfig.formKey"
                        [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.VEHICLE_CONDITION)]"
                        (markAsDirty)="markAsDirty($event)"
                >
                </app-select>
            </div>

            <div class="section__component col-50"
                 *ngIf="canFieldDisplayed(consts.DAMAGE_DESCRIPTION) && vehicleStateStateService.vehicleState.vehicleCondition === vehicleCondition.DAMAGED">
                <app-textarea
                        [errorsMap]="formFactoryService.errorsMap"
                        [control]="formGroup.controls[consts.DAMAGE_DESCRIPTION]"
                        [fieldConfig]="formFactoryService.fieldConfig(consts.DAMAGE_DESCRIPTION, formConfig)"
                        [context]="formConfig.formKey"
                        [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.DAMAGE_DESCRIPTION)]"
                        (markAsDirty)="markAsDirty($event)"
                >
                </app-textarea>
            </div>

            <div *ngIf="canFieldDisplayed(consts.ABROAD_IMPORTED)" class="section__component col-50">
                <app-select
                        [errorsMap]="formFactoryService.errorsMap"
                        [control]="formGroup.controls[consts.ABROAD_IMPORTED]"
                        [fieldConfig]="formFactoryService.fieldConfig(consts.ABROAD_IMPORTED, formConfig)"
                        [context]="formConfig.formKey"
                        [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.ABROAD_IMPORTED)]"
                        (markAsDirty)="markAsDirty($event)"
                >
                </app-select>
            </div>

<!--            <div *ngIf="canFieldDisplayed(consts.REGISTRATION_NUMBER)" class="section__component col-50">-->
<!--                <app-text-field [bean]="bean"-->
<!--                                [errorsMap]="formFactoryService.errorsMap"-->
<!--                                [control]="formGroup.controls[consts.REGISTRATION_NUMBER]"-->
<!--                                [fieldConfig]="formFactoryService.fieldConfig(consts.REGISTRATION_NUMBER, formConfig)"-->
<!--                                [context]="formConfig.formKey"-->
<!--                                [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.REGISTRATION_NUMBER)]"-->
<!--                                (markAsDirty)="markAsDirty($event)"-->
<!--                >-->
<!--                </app-text-field>-->
<!--            </div>-->

            <div *ngIf="canFieldDisplayed(consts.FIRST_REGISTRATION_DATE)"
                 class="section__component col-50 datepicker-component">
                <app-material-datepicker [errorsMap]="formFactoryService.errorsMap"
                                         [control]="formGroup.controls[consts.FIRST_REGISTRATION_DATE]"
                                         [fieldConfig]="formFactoryService.fieldConfig(consts.FIRST_REGISTRATION_DATE, formConfig)"
                                         [context]="formConfig.formKey"
                                         [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.FIRST_REGISTRATION_DATE)]"
                                         (markAsDirty)="markAsDirty($event)"></app-material-datepicker>
            </div>

        </div>
    </ng-template>
</app-section>
